/**
 * Local, plain-string i18n shim (Valkyrie port).
 *
 * Replaces `@eventbrite/i18n`'s `gettext`, whose `GenericLazyString` return
 * value is unsafe to render directly in React 19 (see memory.md). This returns
 * a plain string with `%(name)s`-style interpolation, matching the eb-ui
 * catalog's placeholder syntax.
 *
 * The consuming app is responsible for wiring a real translation catalog
 * (react-intl); until then these render the source (en_US) strings verbatim,
 * exactly as eb-ui did with an unresolved catalog.
 */
export const gettext = (
    text: string,
    params?: Record<string, string | number>,
): string => {
    if (!params) {
        return text;
    }

    return text.replace(/%\((\w+)\)s/g, (match, key: string) =>
        key in params ? String(params[key]) : match,
    );
};
